import { ReactNode } from 'react';
import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import useIsMobile from 'hooks/useIsMobile';
import useSessionInitialSetup from 'hooks/useSessionInitialSetup';
import If from 'components/If';
import Sidebar from 'components/Sidebar';
import CriticalNotification from 'components/CriticalNotification';
import SessionModalSequence from './SessionModalSequence';
import styles from './Layout.module.scss';

type Props = {
  children: ReactNode;
};

function WithSidebar({ children }: Props) {
  useSessionInitialSetup();
  const isMobile = useIsMobile();

  return (
    <Layout className={styles.withSiderbarContainer}>
      <If condition={!isMobile}>
        <Sidebar />
      </If>
      <Content className={styles.content}>
        <CriticalNotification />
        <div id='main-content' className={styles.mainContent}>
          {children}
        </div>
      </Content>
      <SessionModalSequence />
    </Layout>
  );
}

export default WithSidebar;
